import * as Yup from "yup";

export const validatePassword = (required) => {
  const validation = Yup.string()
    .matches(/[A-Z]/, "Phải chứa ít nhất 1 ký tự viết hoa")
    .matches(/[a-z]/, "Phải chứa ít nhất 1 ký tự viết thường")
    .matches(/\d/, "Phải chứa ít nhất 1 số")
    .matches(
      /^.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?].*$/,
      "Phải chứa ít nhất 1 ký tự đặc biệt"
    )
    .matches(/^.{8,}$/, "Ít nhất 8 ký tự");
  if (required) return validation.required("Không được trống");
  return validation;
};

export const yupStringRequired = Yup.string().required("Không được trống");

export const yupNumberRequired = Yup.number()
  .required("Không được để trống")
  .typeError("Chỉ được nhập số")
  .integer("Chỉ được nhập số nguyên")
  .min(0, "Nhỏ nhất là 0");

export const yupDateRange = Yup.lazy((value) => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  return Yup.object().shape({
    from: Yup.date()
      .typeError("Định dạng ngày không đúng")
      .max(today, "Ngày lớn hơn ngày tối đa"),
    to: Yup.date()
      .typeError("Định dạng ngày không đúng")
      .max(today, "Ngày lớn hơn ngày tối đa")
      .test({
        name: "minFrom",
        message: "Ngày nhỏ hơn ngày tối thiểu",
        test: (to) => value.from.getTime() <= to.getTime(),
      }),
  });
});
